import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { matchKnownRoutePattern } from "./routePatterns";
import { recordUserBehaviorEvent } from "@/services/analytics/userBehaviorEvents.api";

/**
 * Records a PageView user-behavior event (to VictoriaMetrics, via the backend) on every route
 * change. Sibling to AppInsightsRouteTracker.tsx - kept separate since that component's
 * responsibility is App Insights specifically, not this VM-backed analytics pipe.
 */
export function RouteBehaviorTracker() {
  const location = useLocation();

  useEffect(() => {
    const pattern = matchKnownRoutePattern(location.pathname);
    if (pattern) {
      recordUserBehaviorEvent("PageView", { route: pattern });
    }
  }, [location.pathname]);

  return null;
}
